import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect, useRef } from "react";
import { Grid, Button, DialogProject, Tabs, Typography, ListItem, ListItemText, Collapse, List, ExpandMore, Paper, makeStyles, BestPracticeInfo, ChevronRightIcon } from "../../../../../";
import { Tooltip } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Link } from "react-router-dom";
var useStyles = makeStyles(function (theme) {
  return {
    mr30: {
      "margin-right": "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    pl30: {
      paddingLeft: "30px"
    },
    mt30: {
      marginTop: "30px"
    }
  };
});

var FranchiseProjectsBestPracticesSingle = function FranchiseProjectsBestPracticesSingle(_ref) {
  var template = _ref.template,
      createProject = _ref.createProject,
      currency = _ref.currency,
      translation = _ref.translation,
      type = _ref.type,
      getDialogData = _ref.getDialogData,
      props = _objectWithoutProperties(_ref, ["template", "createProject", "currency", "translation", "type", "getDialogData"]);

  var classes = useStyles(); //Add project from template

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openAddProject = _useState2[0],
      setOpenAddProject = _useState2[1];

  var _useState3 = useState("plan"),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      settingsCollapse = _useState6[0],
      setSettingsCollapse = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      contacts = _useState8[0],
      setContacts = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      opportunities = _useState10[0],
      setOpportunities = _useState10[1]; // console.log("FranchiseBestPracticesSingle template", template);


  var setInitialSettings = function setInitialSettings(template) {
    var initialSettings = [];
    template.phases.forEach(function (item) {
      if (item.children.length > 0) {
        var itemsChildren = item.children.map(function (_item) {
          var __itemFound = template.phases.find(function (__item) {
            return _item === __item.key;
          });

          return {
            id: __itemFound.key,
            status: __itemFound.status
          };
        });
        initialSettings.push({
          id: item.key,
          collapse: true,
          children: itemsChildren
        });
      }
    });
    return initialSettings;
  }; // INITIAL


  useEffect(function () {
    template && setSettingsCollapse(setInitialSettings(template));
  }, [template]);

  var handleDialogProject = function handleDialogProject() {
    if (!openAddProject) {
      // const invoice = invoices.find(invoice => invoice._id === id);
      // console.log("handleItemViewInvoice invoice", invoice);
      getDialogData().then(function (response) {
        setContacts(response.data.contacts.map(function (opportunity) {
          return {
            value: opportunity._id,
            label: opportunity.name
          };
        }));
        setOpportunities(response.data.opportunities.map(function (opportunity) {
          return {
            value: opportunity._id,
            label: opportunity.name
          };
        }));
        setOpenAddProject(true);
      });
    } else {
      setOpportunities(null);
      setContacts(null);
      setOpenAddProject(false);
    }
  };

  var handleCollapseSelected = function handleCollapseSelected(id) {
    var auxSettingsCollapse = settingsCollapse.map(function (settings) {
      if (settings.id === id) {
        return _objectSpread(_objectSpread({}, settings), {}, {
          collapse: !settings.collapse
        });
      }

      return _objectSpread({}, settings);
    });
    setSettingsCollapse(auxSettingsCollapse);
  };

  var handleTabs = function handleTabs(e, newValue) {
    setValue(newValue);
  };

  var rTaskRender = function rTaskRender(item, tab, lastItem) {
    var isParent;

    if (item.children.length > 0) {
      isParent = true;
    } else {
      isParent = false;
    }

    return /*#__PURE__*/React.createElement(List, {
      style: {
        paddingTop: "0"
      }
    }, /*#__PURE__*/React.createElement(Paper, {
      style: {
        marginLeft: tab * 25 + "px",
        marginBottom: isParent ? "8px" : "0",
        height: "56px",
        backgroundColor: isParent && "#b7b6b682"
      }
    }, /*#__PURE__*/React.createElement(ListItem, {
      id: item.key,
      key: item.key
    }, isParent ? /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        cursor: "pointer",
        flex: "1 1 auto"
      },
      onClick: function onClick() {
        return handleCollapseSelected(item.key);
      }
    }, settingsCollapse && settingsCollapse.find(function (settings) {
      return settings.id === item.key;
    }) ? settingsCollapse && settingsCollapse.find(function (settings) {
      return settings.id === item.key;
    }).collapse ? /*#__PURE__*/React.createElement(ChevronRightIcon, null) : /*#__PURE__*/React.createElement(ExpandMore, null) : null, item.name))) : /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "1 1 auto"
      }
    }, item.name))))), /*#__PURE__*/React.createElement(Collapse, {
      "in": settingsCollapse && settingsCollapse.find(function (settings) {
        return settings.id === item.key;
      }) ? settingsCollapse && settingsCollapse.find(function (settings) {
        return settings.id === item.key;
      }).collapse ? false : true : true
    }, item.children.map(function (_item, index, array) {
      var nextItem = template.phases.find(function (__item) {
        return __item.key === _item;
      });
      return rTaskRender(nextItem, tab + 1, array.length - 1 === index ? true : false);
    })));
  };

  var setContentProject = function setContentProject() {
    var auxContent = [];

    switch (value) {
      case "plan":
        var auxPlanContent = template.phases.find(function (item) {
          return item.key === "plan";
        });
        auxPlanContent.children.length > 0 && auxPlanContent.children.forEach(function (item, position, array) {
          auxContent.push(rTaskRender(template.phases.find(function (_item) {
            return _item.key === item;
          }), 0, array.length <= 1 ? true : position === array.length - 1 ? true : false));
        });
        break;

      case "docheck":
        var auxDoCheckContent = template.phases.find(function (item) {
          return item.key === "docheck";
        });
        auxDoCheckContent.children.length > 0 && auxDoCheckContent.children.forEach(function (item, position, array) {
          auxContent.push(rTaskRender(template.phases.find(function (_item) {
            return _item.key === item;
          }), 0, array.length <= 1 ? true : position === array.length - 1 ? true : false));
        });
        break;

      case "close":
        var auxCloseContent = template.phases.find(function (item) {
          return item.key === "close";
        });
        auxCloseContent.children.length > 0 && auxCloseContent.children.forEach(function (item, position, array) {
          auxContent.push(rTaskRender(template.phases.find(function (_item) {
            return _item.key === item;
          }), 0, array.length <= 1 ? true : position === array.length - 1 ? true : false));
        });
        break;

      default:
        break;
    }

    return auxContent;
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, opportunities && contacts && template && template && template.phases && template.phases.length > 3 && /*#__PURE__*/React.createElement(DialogProject, {
    open: openAddProject,
    translation: translation ? translation.dialogs.add_project : null,
    onClose: handleDialogProject,
    variant: "add",
    contacts: contacts,
    opportunities: opportunities,
    template: {
      id: template._id,
      type: type
    },
    fromBestPractice: true,
    createProject: createProject,
    currency: currency
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Back to best practices"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    color: "primary",
    component: Link,
    to: "/projects/best-practices"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, {
    color: "primary"
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      color: "#fafafa"
    }
  }, translation ? translation.title : "Best Practices")), template && template.phases && template.phases.length > 3 && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium" // className={classes.mr30}
    ,
    color: "primary",
    variant: "contained",
    onClick: handleDialogProject
  }, translation ? translation.buttons.add_project : "Add project from template"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.mt30
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    xs: template && template.phases && template.phases.length > 3 ? 6 : 12,
    md: template && template.phases && template.phases.length > 3 ? 6 : 12,
    lg: template && template.phases && template.phases.length > 3 ? 6 : 12
  }, template && /*#__PURE__*/React.createElement(BestPracticeInfo, {
    template: template,
    type: type
  })), template && template.phases && template.phases.length > 3 && /*#__PURE__*/React.createElement(Grid, {
    xs: 6,
    md: 5,
    lg: 5,
    className: classes.pl30
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    style: {
      marginBottom: "20px"
    },
    onChange: handleTabs,
    variant: "fullWidth",
    indicatorColor: "primary",
    textColor: "primary",
    contentTabs: [{
      label: "Plan",
      value: "plan"
    }, {
      label: "Do&Check",
      value: "docheck"
    }, {
      label: "Close",
      value: "close"
    }]
  }), template && setContentProject()))));
};

export { FranchiseProjectsBestPracticesSingle };